import React from 'react';

const Testimonials = () => {
  return (
    <div
      name="testimonials"
      className="w-full py-8 bg-gradient-to-r from-sky-950 via-slate-800 to-slate-900"
    >
      <div className="max-w-screen-lg px-9 mx-auto flex flex-col justify-center w-full">
        <div className="mb-14">
          <p className="text-4xl text-white font-bold inline border-b-4 border-white">
            Testimonials
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-16 gap-8">
          {/* Testimonial 1 */}
          <div className="bg-white/10 backdrop-blur-md p-6 rounded-2xl shadow-lg hover:scale-105 transition-transform duration-300 text-white">
            <p className="mb-4 italic text-lg">
              "Working with Eden completely transformed our brand
              presence online. The designs are clean, intuitive, and always
              delivered on time."
            </p>
            <div className="flex items-center mt-4">
              <div className="w-8 h-8 rounded-full bg-cyan-400 mr-4 flex-shrink-0 flex items-center justify-center text-black font-semibold">
                K
              </div>
              <div>
                <h3 className="text-xl font-semibold">Kaleab Zelalem</h3>
                <p className="text-cyan-300 text-sm">CEO, Nihao Habesha</p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white/10 backdrop-blur-md p-6 rounded-2xl shadow-lg hover:scale-105 transition-transform duration-300 text-white">
           <p className="mb-4 italic text-lg">
        "Eden exceeded expectations on our brand, delivering creative and professional visual content. Highly recommended."
        </p>
            <div className="flex items-center mt-4">
            <div className="w-8 h-8 rounded-full bg-cyan-400 mr-4 flex-shrink-0 flex items-center justify-center text-black font-semibold">
                S
              </div>
              <div>
                <h3 className="text-xl font-semibold">Surafel Birhanu</h3>
                <p className="text-cyan-300 text-sm">Founder & CEO, SLB Trading Plc.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
